import { FilterListOutlined } from '@mui/icons-material'
import { Box, Icon, Typography } from '@mui/material'
import CheckboxInput from './CheckboxInput'
import { ReactElement, useCallback, useEffect, useRef, useState } from 'react'
import theme from '../../theme/theme'
import { IListItemValue } from '../../interfaces/Interfaces'
import { useTranslation } from 'react-i18next'

interface IFilterIconAndOptions {
    filterList: IListItemValue[]
    filterValues: string[]
    setFilterValues: React.Dispatch<React.SetStateAction<string[]>>
}

const FilterIconAndOptions = (props: IFilterIconAndOptions): ReactElement => {
    const { filterList, filterValues, setFilterValues } = props
    const { t } = useTranslation()
    const dropdownRef = useRef(null)
    const [isFilterOpen, setIsFilterOpen] = useState<boolean>(false)

    const onSelectOptions = useCallback(
        (id: string, value: any) => {
            if (value) {
                setFilterValues((prev) =>
                    prev.includes(id) ? prev : [...prev, id],
                )
            } else {
                setFilterValues((prev) => prev.filter((i) => i !== id))
            }
        },
        [setFilterValues],
    )

    const handleClickOutside = useCallback((event: any) => {
        const container = dropdownRef.current ?? document.body // Fallback to body
        if (container.contains(event.target)) {
            // nothing
        } else {
            setIsFilterOpen(false)
        }
    }, [])

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)
        return () =>
            document.removeEventListener('mousedown', handleClickOutside)
    }, [handleClickOutside])
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '10px',
                position: 'relative',
            }}
            ref={dropdownRef}
        >
            <Icon
                id="filer-list-icon"
                onClick={() => setIsFilterOpen(!isFilterOpen)}
                sx={{ marginLeft: 'auto' }}
                fontSize="small"
            >
                <FilterListOutlined
                    sx={{
                        color: theme.palette.primary.main,
                        marginTop: '-2px',
                    }}
                />
            </Icon>
            {isFilterOpen ? (
                <Box
                    sx={{
                        position: 'absolute',
                        background: '#fff',
                        zIndex: '111',
                        minWidth: '130px',
                        left: '30px',
                        top: '0px',
                        boxShadow: '0px 3px 6px 0px rgba(0,0,0,0.4)',
                        '& div:not(:first-of-type)': {
                            padding: '8px 15px',
                            borderTop: '1px solid rgba(0,0,0,0.2)',
                        },
                        borderRadius: '3px',
                    }}
                >
                    <Box sx={{ padding: '7px 17px' }}>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: '700',
                            }}
                        >
                            {t('filter')}
                        </Typography>
                    </Box>
                    {filterList?.map((item) => (
                        <Box key={item.id + '-checkbox'}>
                            <CheckboxInput
                                id={item.id}
                                label={t(item.name)}
                                value={filterValues?.includes(item.id)}
                                onChange={onSelectOptions}
                            />
                        </Box>
                    ))}
                </Box>
            ) : null}
        </Box>
    )
}

export default FilterIconAndOptions
